
































import { Component, Vue, Inject } from 'vue-property-decorator';
import {EventService} from "@/services/EventService";
import {EventModel} from "@/models/Event/EventModel";
import {get} from "@/context/context";
import CommonButton from "@/components/common/CommonButton.vue";
import ServerSelect from "@/components/form/ServerSelect.vue";
import {ListRequest} from "@/models/Event/ListRequest";
import EventItem from "@/components/other/EventItem.vue";
import AlertUtil from "@/utils/AlertUtil";

@Component({
  components: {
    EventItem,
    ServerSelect,
    CommonButton,
  },
})
export default class EventList extends Vue {
  @Inject()
  private alertTokenError!: AlertUtil;

  private eventService: EventService = get('eventService');
  private isLogging: boolean = false;
  private list:Array<EventModel>|[] = [];
  private page: number = 1;
  private userToken: string|boolean = false;
  private host: string = '';

  private async handleChangeServer(userToke: string|boolean) {
    this.userToken = userToke;
    if (this.userToken && typeof this.userToken === "string") {
      this.alertTokenError.close();
      const request = new ListRequest({userId: this.userToken, pageNotStarted: this.page});
      const data = await this.eventService.getEvents(request);
      this.list = data.notStarted.eventList;
    } else {
      this.list = [];
      this.alertTokenError.open();
    }
  }

  private handleChangeHost(host: string) {
    this.host = host;
  }

  private handleSelectEvent(id: string) {

  }
}
